export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оберіть магазин"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Без назви"])}
}